import { IconMessageChatbot } from '@tabler/icons-react';
import React from 'react';
import { getUnreadDisplayCount } from '../../../../core/utils/string';
import { TRACKER_SUPPORT_MENU_LIVE_CHAT_CLICK } from '../../../../core/constants/constants';
import { AppbarMenuItem } from '../appbar-item-with-menu/AppbarMenuItem';

export function LiveSupportMenuItemComponent({
  supportUnreadCount,
  onClick
}: {
  supportUnreadCount: number;
  onClick: Function;
}) {
  return (
    <AppbarMenuItem
      SVGIcon={IconMessageChatbot}
      onClick={onClick}
      trackingEvent={TRACKER_SUPPORT_MENU_LIVE_CHAT_CLICK}
    >
      <div className='center-flex-row'>
        Live Chat Support
        {supportUnreadCount ? (
          <span className='badge overlay-badge overlay-badge-error ml-2'>
            {getUnreadDisplayCount(supportUnreadCount)}
          </span>
        ) : null}
      </div>
    </AppbarMenuItem>
  );
}
